import { InformacionBusquedaUsuario, SelectCombo } from 'components/Types/GeneralTypes'
import React, { useState } from 'react'
import { Container, Row, Col, Form, Input, Label, Button } from "reactstrap"

import { FormGroup } from 'react-bootstrap'
import FindAsyncSelect from 'components/Varios/SelectsComponent/FindAsyncSelect'
import { showAlert } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import { BuscarInformacionPersonaByIdentificacion, BuscarInformacionPersonaByNombreApellido } from './ServicesSolicitudHEManual'
import ModalCargando from 'components/Varios/ModalCargando'


type PropsBuscadorServidor = {
    onChangePersona:(datosPersona:string) =>  void
}

export default function BuscadorServidor(props:PropsBuscadorServidor) {

    const [identificacion, setidentificacion] = useState<string>("")
    const [nombresSeleccionado, setnombresSeleccionado] = useState<SelectCombo | undefined | null>()
    const [loadingidentificacion, setloadingidentificacion] = useState<boolean>(false)
    const [buscandoinfoservidorhe, setbuscandoinfoservidorhe] = useState<boolean>(false)

    function MapearInformacionUsuario(info: InformacionBusquedaUsuario) {
        const informacionMapeada: SelectCombo = {

            label: info.apellidos + " " + info.nombres,
            value: info.idpersona.toString() + "|" + info.identificacion + "|" + info.apellidos + "|" + info.nombres
        }
        return informacionMapeada
    }


    function OnChangeSelectApellidoNombre(seleccionado: SelectCombo | undefined) {
        if (seleccionado) {
            const informacionDivision = seleccionado?.value.split("|")
            const idpersona: number = +informacionDivision[0]
            const identific: string = informacionDivision[1]

            setidentificacion(identific)
            setnombresSeleccionado(seleccionado)
            props.onChangePersona(seleccionado?.value)
        }
        else {
            setnombresSeleccionado(seleccionado)
        }

    }

    async function ObtenerInformacionByCedula(identificacion: string) {
        if (identificacion.length === 10) {
            setidentificacion(identificacion)
            setloadingidentificacion(true)
            const respuesta = await BuscarInformacionPersonaByIdentificacion(identificacion)
            if (respuesta.status === 200 && respuesta.dataResponse) {

                const v = respuesta.dataResponse;
                const informacionMapeada: SelectCombo = MapearInformacionUsuario(v);
                setnombresSeleccionado(informacionMapeada);
                props.onChangePersona(informacionMapeada.value)
            }
            else {
                showAlert("No se ha encontrado información con la identificación indicada", false);
            }
            setloadingidentificacion(false)
        }
        else if (identificacion.length < 10 && identificacion.length >= 0) {
            setidentificacion(identificacion)
            if(identificacion.length === 0){
                setnombresSeleccionado(null)
            }
        }
        else {
            showAlert("Solo puede ingresar 10 dígitos", false);
        }
    }







    async function ObtenerInformacionByNombreApellido(nombreapellido: string) {
        const respuesta = await BuscarInformacionPersonaByNombreApellido(nombreapellido)
        if (respuesta.status === 200 && respuesta.dataResponse && respuesta.dataResponse.length > 0) {
            const informacionMapeada: SelectCombo[] = respuesta.dataResponse.map((v, i) => {
                return MapearInformacionUsuario(v)
            })
            return informacionMapeada
        }
        else if (respuesta.status === 204) {
            return []//undefined;
        }
        else {
            return []//undefined;
        }
    }

    return (
        <>
            <Form>
            {

                <Row className="">
                    <Col md="2">
                        <FormGroup>
                            <Label>Identificacion</Label>
                            <Input
                                value={identificacion}
                                // disbled={nombres !== ""}
                                type="text"
                                name="identificacionOtraUnidad"
                                placeholder="Ingrese identificación"
                                autoComplete="off"
                                onChange={(e) => ObtenerInformacionByCedula(e.target.value)}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="5">
                        <FormGroup>
                            <Label>Apellidos/Nombres</Label>
                            <FindAsyncSelect
                                value={nombresSeleccionado}
                                icon="fa-caret-down"
                                placeholder='Ingrese Apellidos/Nombres'
                                onFind={(valor) => ObtenerInformacionByNombreApellido(valor)}
                                onChange={(valor) => OnChangeSelectApellidoNombre(valor)}
                                name="nombreApellidoOtraUnidad"
                                noOptionsMessage="Ingresa un apellido o nombre"

                            />
                        </FormGroup>
                    </Col>
                </Row>

            }

        </Form>
        <ModalCargando
            show = {loadingidentificacion}
            size='md'
            onClose={() => setloadingidentificacion(false)}
        />
        </>
        
    )
}
